import "@finanedi.es/front/style.css"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import AfterbanksNotificationsProvider from "context/afterbankContext"
import "primeflex/primeflex.css"
import "primeicons/primeicons.css"
import "primereact/resources/themes/saga-blue/theme.css"
import { createRoot } from "react-dom/client"
import { Toaster } from "react-hot-toast"
import "react-notifications-component/dist/theme.css"
import { Provider } from "react-redux"
import "react-sortable-tree/style.css"
import "./@legacy/@bit/gedesco.reactcomponentsgdc.styles/dist/main.scss"
import App from "./app/App"
import interceptors from "./app/config/axios.interceptors"
import { store } from "./app/store"
import DownloadFileProvider from "./common/context/DownloadFileProvider"
import FinanwayAppWrapper from "./common/context/WithAppWrapper"
import "./common/utils/fontawesome"
import "./config/i18next.config"
import "./index.scss"
import "./styles.tailwind-fs.css"
import "./styles.tailwind.css"
import "./styles/main.scss"

const domNode = document.getElementById("root")
const root = createRoot(domNode as HTMLElement)

interceptors.setupInterceptors(store)
const queryClient = new QueryClient()

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <DownloadFileProvider>
        <AfterbanksNotificationsProvider>
          <FinanwayAppWrapper>
            <Toaster position='top-right' />
            <App />
          </FinanwayAppWrapper>
        </AfterbanksNotificationsProvider>
      </DownloadFileProvider>
    </Provider>
    <ReactQueryDevtools
      initialIsOpen={false}
      buttonPosition='bottom-left'
    />
  </QueryClientProvider>
)

// @ts-expect-error TS(2339): Property 'Cypress' does not exist on type 'Window ...
if (window.Cypress) {
  // @ts-expect-error TS(2339): Property 'store' does not exist on type 'Window & ...
  window.store = store
}
